import { render } from "./DailyDoor.vue?vue&type=template&id=664814fe"
import script from "./DailyDoor.vue?vue&type=script&lang=js"
export * from "./DailyDoor.vue?vue&type=script&lang=js"
script.render = render

export default script